import { StringManager } from "./string.manager";

export class ObjectChecker {
  static isFilled(obj: any): boolean {
    if (obj === undefined || obj === null) {
      return false;
    }

    return Object.keys(obj).some((key) => obj[key] !== undefined && obj[key] !== null && obj[key] !== '');
  }
  static transformToCamelCase<T extends object>(obj: T): { [K in keyof T]: unknown } {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      acc[StringManager.snakeToCamel(key)] = value;
      return acc;
    }, {} as { [K in keyof T]: unknown });
  }
}
